import NavBar from 'common/components/NavBar'
import React from 'react'
import { Outlet, useLocation } from 'react-router'
import BoundaryError from 'common/components/BoundaryError'

// Layout de la section Roadmap : NavBar secondaire (Roadmap / Priorités) + Outlet.
const RoadmapMenuApp = () => {
    const { pathname } = useLocation()

    const links = [
        { icon: 'flag', tooltip: 'Priorités', url: '/roadmap/priorites' },
        { icon: 'event', tooltip: 'Roadmap', url: '/roadmap' },
    ]
    return (
        <>
            <NavBar links={links} />
            <BoundaryError url={pathname}>
                <div style={{ marginLeft: '65px' }}>
                    <Outlet />
                </div>
            </BoundaryError>
        </>
    )
}

export default RoadmapMenuApp
